import {get} from 'lodash';
import store from './store';
export default async (uri, options) => {
    this.tokenRequest = null
    const initialRequest = await fetch(uri, options)
  console.log('customFetch')
  
    const clonedRequest = await initialRequest.clone()
    const response = await clonedRequest.json()
  const user=store.state.auth.id;
 
    const accessTokenHasExpired =
      get(response, 'errors', []).filter(error => error.message === 'Could not verify JWT: JWTExpired')
        .length > 0
  
    if (accessTokenHasExpired && !this.tokenRequest) {
      console.log('accessToken has expired, try getting a new one')
  
      this.tokenRequest = await fetch(process.env.SERVER_URL+'/auth/refetch-token', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
        
          refetch_token: window.localStorage.getItem('refetch_token'),
          user_id:user
        
        }),
      })
  
      if (this.tokenRequest.status !== 200) {
        // TODO: clear everything about the user
        // and send them to home screen
        console.log('Could not update the accessToken #1')
        store.dispatch('AUTH_LOGOUT')

        return initialRequest
      }
  
      const { jwt_token,refetch_token } = await this.tokenRequest.json()
      options.headers.authorization = `Bearer ${jwt_token }`
      console.log('Fetch with new accessToken', jwt_token )
  
      this.tokenRequest = null
  
      //setAccessToken(accessToken)
      window.localStorage.setItem('jwt_token',jwt_token)
      window.localStorage.setItem('refetch_token',refetch_token)
      return fetch(uri, options).catch(res => {
        console.log('Could not update the accessToken #2')
        
      })
    }
  
    return initialRequest
  }


// WEBPACK FOOTER //
// ./src/customFetch.js